import React from 'react';
import PropTypes from 'prop-types';
import { List, Subheader, Divider, Paper, IconButton } from 'material-ui';
import { white } from 'material-ui/styles/colors';
import FileDownloadIcon from 'material-ui/svg-icons/file/file-download';
import Error from '../../common/Error/Error';
import style from '../../../styles/styles';
import UserAchievementItem from '../UserAchievementItem/UserAchievementItem';
import APIService from '../../../services/api';
import styles from './UserAchievementList.css';
import withTranslation from '../../../hoc/withTranslation';
import { Cookies } from 'react-cookie';
const cookies = new Cookies();

const UserAchievementList = (props) => {
    const {
        app,
        userAchievements,
        lang,
        title,
        t,
        achievementId
    } = props;

    let content;

    const getCsv = async() => {
        const response = await APIService.getUserAchievements(
            app,
            cookies.get('token'),
            lang,
            'csv',
            true,
            null,
            achievementId === undefined ? null : achievementId
        );
        const type = response.headers['content-type'].split(';')[0];
        const filename = 'user_achievements.csv';
        const blob = new Blob([response.data],
            {
                type: type,
                encoding: 'UTF-8',
            },
        );
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    };

    if (userAchievements.length === 0) {
        content =
            <Error
                title="No data"
                subtitle=""
            />;
    } else {
        content = userAchievements
            .sort((a, b) => {
                return b.created_at - a.created_at;
            })
            .map(function (userAchievement, index) {
                return <div key={userAchievement.achievement.id
                    + userAchievement.user.id
                    + userAchievement.created_at}>
                    <UserAchievementItem userAchievement={userAchievement} />
                    {index !== (
                        userAchievement.length - 1
                    ) && <Divider inset={true} />}
                </div>;
            });
    }

    return (
        <Paper>
            <List>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {title}
                    <IconButton
                        style={styles.rightIcon}
                        tooltipPosition="bottom-left"
                        tooltip={t('module.gamification.download_csv')}
                        onClick={getCsv}
                    >
                        <FileDownloadIcon color={white} />
                    </IconButton>

                </Subheader>
                {content}
            </List>
        </Paper>
    );
};

UserAchievementList.propTypes = {
    app: PropTypes.object.isRequired,
    userAchievements: PropTypes.array.isRequired,
    title: PropTypes.string,
    lang: PropTypes.string,
};

export default withTranslation(UserAchievementList);



// WEBPACK FOOTER //
// src/components/achievement/UserAchievementList/UserAchievementList.js